import dummy from './buildings/yeoksam.json';

export class TmapRouter {
	constructor({ license, sender, naviRef }) {
		this.license_ = license;
		this.sender_ = sender;
		this.naviRef_ = naviRef;
		this.building_state_ = true;
		this.tracking_flag = true;
		this.timer_panning_ = setTimeout(this.onTracking, 5000);
		this.destination_set_flag = false;
		this.lonlat_curPos_ = '';
		this.initialized_ = false;
		this.lines_ = [];
		this.map_ = '';
		this.poly_markers_ = [];
		this.parking_talbes_ = [];
		this.parking_info_text_ = [];
		this.confirm_ = false;
		this.cur_loc_ = '';
		this.dest_loc_ = '';
	}

	init() {
		const api_header = document.createElement('script');
		api_header.type = 'text/javascript';
		api_header.src = 'third_party_api/tmap/tmapjs2.min.js';
		// api_header.src = "https://apis.openapi.sk.com/tmap/jsv2?version=1&appKey=l7xxe2550fd7961c489a816475f6743c6c5b";
		api_header.addEventListener('load', () => {
			this.lonlat_curPos_ = new Tmapv2.LatLng(
				37.41410414557378,
				126.88557657832663,
			); // default location

			const navi = this.naviRef_;
			this.map_ = new Tmapv2.Map(navi, {
				center: this.lonlat_curPos_,
				zoom: 18,
			});
			this.map_.setOptions({ zoomControl: false });

			//* click event
			this.map_.addListener('click', this.addMarker);
			// this.map_.addListener("touchstart", this.getTouchPosition);
			// this.map_.addListener("touchend", this.addTouchedMarker);
			// this.map_.addListener("touchstart", this.onMoveStart);
			// this.map_.addListener("touchend", this.onMoveEnd);
			// this.map_.addListener("dragstart", this.onMoveStart);
			// this.map_.addListener("dragend", this.onMoveEnd);

			this.marker_cur_loc = new Tmapv2.Marker({
				position: this.lonlat_curPos_,
				icon: 'asset/icon/pin_car.png',
				map: this.map_,
			});

			this.initialized_ = true;
		});
		document.head.append(api_header);
	}

	updatePosition(pos) {
		if (
			!!this.marker_cur_loc &&
			!!this.map_ &&
			!!pos &&
			!!pos.lat &&
			!!pos.lon
		) {
			try {
				this.lonlat_curPos_ = new Tmapv2.LatLng(pos.lat, pos.lon);
				this.marker_cur_loc.setPosition(this.lonlat_curPos_);
				this.map_.panTo(this.lonlat_curPos_);
			} catch (e) {
				console.error('Error updating position:', e, 'pos:', pos);
			}
		}
	}

	addMarker = (e) => {
		this.removeMarker();
		for (let i = 0; i < this.poly_markers_.length; i++) {
			this.poly_markers_[i].setMap(null);
		}
		this.poly_markers_ = [];

		this.lonlat = e.latLng;
		this.marker = new Tmapv2.Marker({
			position: new Tmapv2.LatLng(this.lonlat.lat(), this.lonlat.lng()),
			map: this.map_,
		});

		this.marker.addListener('click', this.onClick);
	};

	removeMarker = () => {
		try {
			this.marker.setMap(null);
		} catch (e) {
			// console.log("[info] no markers to remove");
		}
	};

	onClick = () => {
		this.cur_loc_ = this.marker_cur_loc.getPosition();
		this.dest_loc_ = this.marker.getPosition();

		// global path create
		this.buildingInfo();
	};

	getRoute = () => {
		this.resettingMap();
		for (let i = 0; i < this.parking_talbes_.length; i++) {
			this.parking_talbes_[i].remove();
		}
		for (let i = 0; i < this.parking_info_text_.length; i++) {
			this.parking_info_text_[i].remove();
		}
		const start = this.cur_loc_;
		const end = this.dest_loc_;

		const optionObj = {
			reqCoordType: 'WGS84GEO',
			resCoordType: 'WGS84GEO',
			trafficInfo: `Y&appKey=${this.license_}`,
		};

		const params = {
			onComplete: (res) => {
				this.onComplete(res);
			},
			onProgress: this.onProgress,
			onError: this.onError,
		};

		// TData object create
		const tData = new Tmapv2.extension.TData();

		// TData path request
		tData.getRoutePlanJson(start, end, optionObj, params);
	};

	onComplete(res) {
		const jsonObject = new Tmapv2.extension.GeoJSON();
		const jsonForm = jsonObject.rpTrafficRead(res._responseData);

		//Traffic info colors
		const trafficColors = {
			trafficDefaultColor: '#000000', //교통 정보가 없을 때
			trafficType1Color: '#009900', //원할
			trafficType2Color: '#7A8E0A', //서행
			trafficType3Color: '#8E8111', //정체
			trafficType4Color: '#FF0000', //정체
		};
		jsonObject.drawRouteByTraffic(this.map_, jsonForm, trafficColors, (evt) => {
			if (evt.markers.length > 0) {
				for (let i = 0; i < evt.markers.length; i++) {
					evt.markers[i].setMap(null);
				}
			}
			this.lines_ = evt.polylines;
		});
		var msg = {
			type: 'user_input',
			text: 'global_route',
			value: res._responseData,
		};
		this.sender_(msg);
	}

	onProgress() {}

	onError() {
		alert('onError');
	}

	buildingInfo() {
		var building_info = dummy.features.map((feature) => {
			return feature.geometry.coordinates;
		});
		var buildings = [];

		// lat, lon change
		building_info.filter((reversedBuilding) => {
			for (let i = 0; i < reversedBuilding.length; i++) {
				const building = [];
				for (let j = 0; j < reversedBuilding[i].length; j++) {
					building.push([...reversedBuilding[i][j]].reverse());
				}
				buildings.push(building);
			}
			return buildings;
		});

		var pointInPolygon = require('point-in-polygon');
		var building_click = [];
		building_click = buildings.filter((building) => {
			return pointInPolygon(
				[this.dest_loc_.lat(), this.dest_loc_.lng()],
				building,
			);
		});
		//sample list 에서 해당 영역의 index
		var building_index = buildings.findIndex((building) => {
			return pointInPolygon(
				[this.dest_loc_.lat(), this.dest_loc_.lng()],
				building,
			);
		});

		//클릭 영역에 주차장 정보가 있는 경우
		if (building_click[0]) {
			//해당 영역 주차층 정보 추출
			const parking_floors = dummy.features[
				building_index
			].properties.parking_floors.map((parking_floor) => {
				return parking_floor.floor;
			});
			//해당 영역 polygon 생성
			const polygon_path = [];
			for (let i = 0; i < building_click[0].length; i++) {
				polygon_path.push(
					new Tmapv2.LatLng(building_click[0][i][0], building_click[0][i][1]),
				);
			}
			const building_polygon = new Tmapv2.Polygon({
				paths: polygon_path,
				strokeWeight: 2,
				strokeColor: '#FF3DE5',
				strokeOpacity: 0.6,
				fillColor: '#FF8AEF',
				fillOpacity: 0.5,
			});
			building_polygon.setMap(this.map_);
			this.poly_markers_.push(building_polygon);

			//floortable 생성 함수
			this.floorTable(parking_floors, building_index);
		}
		//no parking info
		else {
			this.getRoute();
		}
	}

	floorTable(parking_floors, building_index) {
		const floor_number = [];
		const table_img = [];
		const table_text = [];
		for (let i = 0; i < parking_floors.length; i++) {
			//floor, map ID
			floor_number[i] =
				dummy.features[building_index].properties.parking_floors[
					parking_floors.length - i - 1
				].floor;
			const mapId =
				dummy.features[building_index].properties.parking_floors[
					parking_floors.length - i - 1
				].map_id;
			//floor table image element
			const parent = this.naviRef_;
			table_img[i] = document.createElement('img');
			table_img[i].setAttribute('src', 'https://i.imgur.com/bATjVTc.png');
			table_img[i].setAttribute('alt', `${floor_number[i]}`);
			table_img[i].className = `${mapId}`;
			table_img[i].style.position = 'absolute';
			table_img[i].style.left = '10%';
			table_img[i].style.top = `${200 - 45 * i}px`;
			table_img[i].style.zIndex = '5';
			parent.appendChild(table_img[i]);
			// document.body.appendChild(table_img[i]);
			this.parking_talbes_.push(table_img[i]);

			//floor number text element
			table_text[i] = document.createElement('b');
			table_text[i].style.position = 'absolute';
			table_text[i].style.left = '13%';
			table_text[i].style.top = `${215 - 45 * i}px`;
			table_text[i].style.zIndex = '6';

			const imgText = document.createTextNode(
				`${parking_floors[parking_floors.length - i - 1]}`,
			);
			table_text[i].appendChild(imgText);
			parent.appendChild(table_text[i]);
			// document.body.appendChild(table_text[i]);
			this.parking_info_text_.push(table_text[i]);

			table_img[i].addEventListener('click', (e) => {
				const floor = e.target.alt;
				const map_info = e.target.className;
				this.confirmDest(floor, map_info);
			});
		}
	}

	confirmDest(floor, map_info) {
		this.confirm_ = window.confirm(`Confirm Destination? (${floor})`);
		for (let i = 0; i < this.parking_talbes_.length; i++) {
			this.parking_talbes_[i].remove();
		}
		for (let i = 0; i < this.parking_info_text_.length; i++) {
			this.parking_info_text_[i].remove();
		}
		if (this.confirm_) {
			this.parking_talbes_ = [];
			this.parking_info_text_ = [];

			this.getRoute();
			//TODO: using map info, parking lot map connect
			this.confirm_ = false;
		}
	}

	resettingMap = () => {
		if (this.lines_.length > 0) {
			for (let i = 0; i < this.lines_.length; i++) {
				this.lines_[i].setMap(null);
			}
		}
	};
}
